import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Components
import { DashboardComponent } from './dashboard.component';
import { DashboardDetailsComponent } from './details/dd.component';
import { CompanyVendorItemsComponent } from './admin/cmp.details.component';

// Services
import { MenuService } from '../../shared/components/menu/menu.service';
import { DashboardService } from './dashboard.service';

import { DbAdminSearchPipe, FilterVendorItemByCategoryPipe, NotFilledPipe } from './pipes';

import { NzModule } from '../../shared/nz.module';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../../shared/pipes.module';
import { LevelPickerModule } from '../../shared/components/level.picker/level.picker.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AccessLevelService } from '../../shared/services/acl.service';
import { SystemUpdatesModule } from '../../shared/components/system-updates/system-updates.module';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardDetailsComponent,

    // For Admin mode
    FilterVendorItemByCategoryPipe,
    DbAdminSearchPipe,
    NotFilledPipe,
    CompanyVendorItemsComponent,
  ],
  imports: [
    NzModule,
    CommonModule,
    RouterModule,
    LevelPickerModule,
    FormsModule,
    PipesModule,
    ScrollingModule,
    SystemUpdatesModule,
  ],
  exports: [DashboardComponent, DashboardDetailsComponent, CompanyVendorItemsComponent],
  providers: [
    DashboardService,
    // VpService
  ],
})
export class DashboardModule {
  constructor(
    private MenuService: MenuService,
    private ACL: AccessLevelService,
  ) {
    // Автоматическая регистрация пункта меню
    this.MenuService.registerMenuItem({
      sortId: 10,
      title: 'Dashboard',
      icon: 'dashboard',
      url: '/dashboard/',
      isCurrent: false,
      acls: this.ACL.getViewAccess('dashboard'),
    });
  }
}
